import React from 'react'
import { useNavigate } from 'react-router-dom'
import { usePermissions } from '../../hooks'

import ContextMenu from '../../components/ContextMenu'
import DropdownMenu, { DropdownItem } from '../../components/DropdownMenu'
import SitesList from '../../components/SitesList'

export default function () {
  const navigate = useNavigate()
  const createPermission = usePermissions('site', 'create')

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Sites</h1>}>
        <DropdownMenu label='Actions'>
          {createPermission && createPermission.granted && (
            <DropdownItem onClick={() => navigate('/sites/create')}>
              Create a new site
            </DropdownItem>
          )}
        </DropdownMenu>
      </ContextMenu>
      <SitesList />
    </div>
  )
}
